import React from 'react'

import Separator from '../../../../../components/pdf/Separator'
import Text from '../../../../../components/pdf/Text'
import View from '../../../../../components/pdf/View'

const CoverSection = () => (
  <View id="6">
    <Text bold size="small">
      6. NORMAS E REFERÊNCIAS BIBLIOGRÁFICAS
    </Text>

    <ul>
      <li>
        <Text>Portaria STRAB 3.214/78, NR-1 – Programa de Gerenciamentos de Riscos – PGR;</Text>
      </li>

      <li>
        <Text>Portaria STRAB 3.214/78, NR-17 - Ergonomia</Text>
      </li>

      <li>
        <Text>
          Normas de Higiene Ocupacional, metodologias, estratégias e técnicas de monitoramento de agentes de riscos
          ocupacionais da FUNDACENTRO/Brasil, ABNT/Brasil: Associação Brasileira de Normas Técnicas,
        </Text>
      </li>

      <li>
        <Text>
          ACGIH/EUA: American Conference of Governamental Industrial Hygienists, NIOSH/EUA: National Institute for
          Occupational Safety and Health e AIHA/EUA: American Industrial Hygiene Association
        </Text>
      </li>
    </ul>

    <Separator weight={8} />
  </View>
)

export default CoverSection
